import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintroundtable = () => {
  const title = "{BRAND.short} Roundtable press release June 2025."

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>{title}</h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on June, 2025</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                On 13 June, {BRAND.domainLabel} hosted a roundtable with mental health
                experts to discuss the platform's industry-leading Next of Kin
                feature — an alert system inspired by the NHS and aimed at
                saving lives online. Expert representatives from leading
                charities including Samaritans, Mental Health Innovations,
                PAPYRUS and campaigner Ellen Roome, who is also fundraising for
                the national charity PAPYRUS Prevention of Young Suicide,
                attended the roundtable and shared valuable insight.
              </p>

              <p>
                The Next of Kin feature on {BRAND.domainLabel} provides users with the
                reassurance that, in the event of a mental health emergency
                while using the platform, trusted individuals that they have
                chosen and consented to will be contacted for support. Inspired
                by the important work of suicide prevention charities,
                {BRAND.domainLabel} have created an informed definition of a mental
                health emergency when Next of Kin would be contacted.
              </p>

              <p>
                This collaborative initiative is part of {BRAND.domainLabel}'s ongoing
                commitment to shape an alternative future for social networking.
                Designed from the ground up, {BRAND.domainLabel} is a platform where
                users are empowered to be their authentic selves in a safer,
                more supportive digital environment.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintroundtable;
